import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
    // const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const isAuthenticated = localStorage.getItem("isAuthenticated");

    return isAuthenticated ? children : <Navigate to="/login" replace />;
};
